import {
  ref,
  computed,
  reactive,
  defineComponent,
  toRefs,
  onMounted,
  toRef,
  nextTick,
  watch,
  onActivated,
} from "vue";
import { message } from "ant-design-vue";
import { bindEmitter } from "@/utils/emitter";
import { BizFileService } from "@/core";
import PrintItem from "./header.vue";
import { TabService } from "@/core";
import Attachment from "./attachment-table/index.vue";
import moment from "moment";
import { useRouter, useRoute } from "vue-router";
import LostOrderBtn from "@/views/project/profile/detail/lost-order-btn.vue";
import { collapsed } from "@/utils/windowResize";
import NoviceGuide from "@/components/novice-guide/index.vue";
import { CheckCircleFilled } from "@ant-design/icons-vue";
import { MoreFlowService } from "./more-flow.service";
import _ from "lodash";
import { tabListArr } from "@/views/project/profile/project-view/view-constant";
export default defineComponent({
  isGlobal: true,
  name: "FormCreate",
  components: { PrintItem, Attachment, LostOrderBtn, CheckCircleFilled },
  props: {
    sections: {
      type: Array,
      default: () => [],
    },
    formModel: {
      type: Object,
      require: true,
    },
    formRules: {
      type: Object,
      require: true,
    },
    attachBizType: {
      type: String,
      default: "",
    },
    submit: {
      type: Function,
      require: true,
    },
    submitNext: {
      type: Function,
      require: true,
    },
    externalValidate: {
      type: Function,
      default: () => {},
    },
    resetFields: {
      type: Function,
      default: () => {},
    },
    createLoading: {
      type: Boolean,
      require: true,
    },
    editLoading: {
      type: Boolean,
      require: true,
      default:true
    },
    labelWidth: {
      type: Number,
      default: 80,
    },
    nestification: {
      type: Array,
      default: () => [],
    },
    initializeField: {
      type: Array,
      default: () => [],
    },
    comName: {
      type: String,
      default: "",
    },
    projectId: {
      type: String,
      default: "",
    },
    showFormFooter: {
      type: Boolean,
      default: true,
    },
    bizType: {
      type: String,
      default: "",
    }, 
    examineAccess: {
      type: String,
      default: "",
    },  
  },
  emits: ["update:basicInfo", "update:attachList"],
  setup(props, { emit }) {
    const formRef = ref();
    const attachRef = ref();
    const router = useRouter();
    const route = useRoute();
    // console.log("NoviceGuide", NoviceGuide);
    const state = reactive({
      errorShow: false,
      loading: false,
      duration: 0,
      positionClass: "",
      id: computed(() => route.params.id),
      isChange: computed(() =>route.query["isChange"] || false),
      isEditSave: computed(() =>route.query["isEditSave"] || false),
      isEdit: computed(() => {
        return !!route.params.id;
      }),
      attachList: [],
      labelCol: { span: 2 },
      wrapperCol: { span: 6 },
      collapsed,
      nowStr: moment().format("YYYY/MM/DD HH:mm"),
      selectedCheckbox: [],
      selectedSection: [
        { label: "标题", value: "header", sort: 1, show: true },
        { label: "基本信息", value: "basic", sort: 2, show: true },
        { label: "附件", value: "attach", sort: 10, show: true },
      ],
      checkboxes: computed(() => {
        let tmp = [] as any;
        props.sections.forEach((o: any) => {
          let t = state.selectedSection.findIndex((i: any) => i.value === o.value);
          if (t < 0) {
            tmp.push(o);
          } else {
            state.selectedSection[t] = Object.assign(state.selectedSection[t], o);
          }
        });
        tmp = [...state.selectedSection, ...tmp];
        tmp.sort((a: any, b: any) => {
          if (a.sort > b.sort) {
            return 1;
          } else if (a.sort < b.sort) {
            return -1;
          } else {
            return 0;
          }
        });
        return tmp;
      }),
      loopSection: computed(() => {
        const tmp = [] as any;
        state.selectedCheckbox.forEach((o) => {
          const t = state.checkboxes.find((i: any) => i.value === o);
          if (t) {
            tmp.push(t);
          }
        });
        return tmp;
      }),
      showQrcode: computed(() => {
        return state.loopSection.some((i) => i.value === "qrcode" && i.show);
      }),
      scrollOption: {
        behavior: (actions) =>
          actions.forEach(({ el, top, left }) => {
            // 60px 就是 header 遮挡的区域
            // console.log(el, "el");
            el.scrollTop = top - 80;
            el.scrollLeft = left;
          }),
      },
      bizTypeVisible: false,
      bizTypeDatas: [],
      funName: "submit",
      checkedBizType: props.bizType,
    });
    state.selectedCheckbox = state.checkboxes.map((o) => o.value);
    const isIframe = window.self !== window.top;

    watch(
      () => props.projectId,
      (n, o) => {
        let flg = false;
        if (!n) {
          flg = true;
        }
        state.checkboxes.forEach((o) => {
          if (typeof o.collapsed === "boolean") {
            o.collapsed = flg;
          }
          if (typeof o.disabled === "boolean") {
            o.disabled = flg;
          }
        });
      },
      {
        immediate: true,
      }
    );
    watch(
      () => state.selectedCheckbox,
      (n) => {
        if (n) {
          // console.log(n);
        }
      },
      { immediate: true, deep: true }
    );

    const cancel = async () => {
      const event = bindEmitter("trigger-keepalive-form-reset" + (route.name as string));
      event(route.name);
      TabService.closeCurrentTab();
      if (isIframe) {
        window.parent.postMessage({ type: 'setShowCard', data: true }, '*');
      }
      router.back();
    };
    const { run: uploadFiles } = BizFileService.useCreateApi();
    const uploadFilesFn = async () => {
      if (state.isEdit) {
        // console.log("state.attachList:", state.attachList);
        const files = state.attachList.map((item) => {
          item.bizId = state.id;
          item.bizType = props.attachBizType;
          return item;
        });
        await uploadFiles(files, state.id, props.attachBizType);
      }
    };

    const reset = (name) => {
      if (name && name.length) {
        // console.log("props.formModel", props.formModel, "name:", name);
        for (let key in props.formModel) {
          if (props.nestification.find((i) => i === key)) {
            if (Array.isArray(props.formModel[key])) {
              if (!props.initializeField.some((n) => n === key)) {
                props.formModel[key] = [];
              }
            } else {
              for (let k in props.formModel[key]) {
                if (!props.initializeField.some((n) => n === k)) {
                  props.formModel[key][k] = undefined;
                }
              }
            }
          } else {
            if (!props.initializeField.some((n) => n === key)) {
              props.formModel[key] = undefined;
            }
          }
        }
        state.attachList = [];
        if (formRef.value) {
          formRef.value.clearValidate();
        }
        // console.log("sssssssssssssss");
        props.resetFields();
      }
      const e = bindEmitter("trigger-keepalive-form-reset" + (route.name as string));
      e("");
    };
    // 清楚form表单数据
    bindEmitter("trigger-keepalive-form-reset" + (route.name as string), (name) => {
      nextTick(() => {
        // console.log(route.name, name, "================================");
        if (route.name === name || "all-component" === name) {
          reset(name);
        }
      });
    });
    const initErrorTip = () => {
      state.positionClass = "ant-form-item-explain";
      state.duration = 3000;
      state.errorShow = true;
    };
    const hiddenTip = () => {
      state.positionClass = "";
      state.duration = 0;
      state.errorShow = false;
    };
    const submitFn = async (event = null, cb) => {
      state.funName = "submit";
      props.formModel && (props.formModel["isSubmit"] = 0);

      if (event) {
        const name = (event as any).submitter.dataset.type;
        if (name) {
          state.funName = name;
          console.log("🚀 ~ file: controller.ts:285 ~ submitFn ~  state.funName:",  state.funName)
          if(name=='submitAndAdd'){
            state.funName = "submit";
            props.formModel && (props.formModel["isSubmit"] = 1);
          }
        }
      }
      state.loading = true;
      setTimeout(()=>{state.loading = false;},1000)

      try {
        initErrorTip();
        const emitEvent = bindEmitter("trigger-form-custom-validator");
        emitEvent("");
        const tmp = await props.externalValidate();
        await formRef.value.validate();

        if (tmp && tmp.length > 0) {
          message.error(tmp[0]);
          state.loading = false;
          return;
        }
        if (!state.isEdit && props.bizType !== "" && state.bizTypeDatas.length > 1) {
          state.bizTypeVisible = true;
          state.loading = false;
        } else {
          await handleSubmit();
        }
      } catch (e: any) {
        const tmp = await props.externalValidate();
        if (tmp && tmp.length > 0) {
          message.error(tmp[0]);
          state.loading = false;
          return;
        }

        if (e.errorFields?.length === 0) {
          // console.log("上传第二次");
          if (!state.isEdit && props.bizType !== "" && state.bizTypeDatas.length > 1) {
            state.bizTypeVisible = true;
            state.loading = false;
          } else {
            await handleSubmit();
          }
        }
      }
      state.loading = false;
    };

    const { run: runBind } = MoreFlowService.useFormBindFlowApi();
    const { run: runGet, data: typeDatas } = MoreFlowService.useFlowTemplateApi();
    let oldProjectId = "";
    const handleSubmit = async () => {
      state.loading = true;
      await uploadFilesFn();
      // console.log("上传第一次");
      //@ts-ignore
      props.formModel && (props.formModel["bizType"] = state.checkedBizType);
      oldProjectId = props.formModel?.projectId;
      //@ts-ignore
      const res = await (props[state.funName] as Function)();

      if (res.respCode === "0000") {
        state.loading = false;
        if (
          !state.isEdit &&
          props.bizType !== "" &&
          state.bizTypeDatas.length > 1 &&
          res.data?.id
        ) {
          let res2 = await runBind({ bizType: state.checkedBizType, bizId: res.data?.id });
          if (res2.respCode === "0000") {
            state.bizTypeVisible = false;
            reset(route.name);
            nextTick(function () {
              formRef.value.resetFields();
              reset(route.name);
            });
          }
        } else {
          state.bizTypeVisible = false;
          reset(route.name);
          nextTick(function () {
            formRef.value.resetFields();
            reset(route.name);
          });
        }
        
        if(oldProjectId&&isIframe&&route.query['projectId']!==oldProjectId){
          let tabObj= tabListArr.find((item)=>{
           return item.key==route.query['iframeKey']}
           );
           if(tabObj){
            nextTick(function () {
             router.push('/project/general-add?addPath='+tabObj.addPath+'&detailPath='+tabObj.path+'&projectId='+route.query['projectId']+'&projectName='+route.query['projectName']+'&iframeKey='+tabObj.key)
            })
            }
         }else if(oldProjectId&&isIframe&&route.query['projectId']==oldProjectId&&route.query['detailPath']){
          console.log("🚀 ~ controller.ts:397 ~ handleSubmit ~ res.data?.id:", res.data?.id)
          if(res.data?.id){
            router.push(route.query['detailPath']+'/'+res.data?.id)
          }
         }
         if (isIframe) {//收起数据概览
           window.parent.postMessage({ type: 'setShowCard', data: true }, '*');
         }
      }
     
      state.loading = false;
    };
    onMounted(() => {
      
      nextTick(() => {
        if (formRef.value) {
          formRef.value.clearValidate();
        }
        if (!state.isEdit && props.bizType !== "") {
          loadBizTypeData();
        }
        if(route.query["projectId"]&&props.formModel){
          props.formModel['projectId'] = route.query['projectId']
        }
      });
    });
    onActivated(() => {
      nextTick(() => {
        if (formRef.value) {
          formRef.value.clearValidate();
        }
        if (!state.isEdit && props.bizType !== "") {
          loadBizTypeData();
        }
        if(route.query["projectId"]&&props.formModel){
          props.formModel['projectId'] = route.query['projectId']
        }
      });
    });
    const loadBizTypeData = async () => {
      let res = await runGet({ bizType: props.bizType });
      if (res.respCode === "0000") {
        //@ts-ignore
        state.bizTypeDatas = _.cloneDeep(typeDatas.value && typeDatas.value.records);
        // // console.log(
        //   "🚀 ~ file: controller.ts ~ line 380 ~ loadBizTypeData ~ state.bizTypeDatas",
        //   state.bizTypeDatas
        // );
      } else {
        state.bizTypeDatas = [];
      }
    };
    const selectTemplate = (biz) => {
      state.checkedBizType = biz;
    };
    return {
      ...toRefs(state),
      cancel,
      submitFn,
      formRef,
      hiddenTip,
      handleSubmit,
      selectTemplate,
      isIframe
    };
  },
});
